export default "__VITE_ASSET__D0fE4W9V__"